import styles from './GateVideoBreaker.module.css';
import Gate from './Gate.js';
import Theme from './Theme.js';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import Link from './Link.js';
import LinkAuthFlow from './LinkAuthFlow.js';
import IconPlusHomepageBackground from './IconPlusHomepageBackground.js';
import IconPlusLogo from './IconPlusLogo.js';
import IconPlusCheckMark from './IconPlusCheckMark.js';
import IconArrowRight from './IconArrowRight.js';

const GateVideoBreaker = () => {
  const { learnMoreUrl, cableProviderLink, product } =
    useSearchParamOrDefaultProps();

  return (
    <Theme>
      <Gate style={{ margin: '0 auto' }}>
        <div className={styles.homepageContainer}>
          <div className={styles.backgroundDark}>
            <div className={styles.gateContainer}>
              <div className={styles.backgroundContainer} />
            </div>
            <div className={styles.containerLeft}>
              <div className={styles.headerLogoContainer}>
                <IconPlusHomepageBackground />
              </div>
            </div>
            <div className={styles.containerPaywallLiveTV}>
              <div className={styles.headerBox}>
                <div className={styles.headerContainer}>
                  <div className={styles.leadHeading}>
                    Watch the CNBC Livestream
                  </div>
                  <div className={styles.subLeadHeading}>
                    Watch every minute of market coverage and stay informed on
                    all breaking news, opinions, and analysis from pre-market
                    buzz to the closing bell, and beyond. Miss a moment? Catch
                    up with full episodes on-demand.
                  </div>
                </div>
              </div>
              <div className={styles.paywallContainer}>
                <div className={styles.plusContent}>
                  <div className={styles.topGateBox}>
                    <div className={styles.plusPaywall}>
                      <div className={styles.logoContainer}>
                        <IconPlusLogo />
                      </div>

                      <div className={styles.paywallBoard}>
                        <div className={styles.paywallHeader}>
                          Join CNBC+ now, and start Streaming Today
                        </div>
                        <div className={styles.paywallText}>
                          <div className={styles.textListLeft}>
                            <div className={styles.textList}>
                              <span className={styles.checkMark}>
                                <IconPlusCheckMark />
                              </span>
                              <span className={styles.featureText}>
                                Global Livestream
                              </span>
                            </div>
                            <div className={styles.textList}>
                              <span className={styles.checkMark}>
                                <IconPlusCheckMark />
                              </span>
                              <span className={styles.featureText}>
                                On-Demand Library
                              </span>
                            </div>
                          </div>
                          <div className={styles.textListRight}>
                            <div className={styles.textList}>
                              <span className={styles.checkMark}>
                                <IconPlusCheckMark />
                              </span>
                              <span className={styles.featureText}>
                                Market Data Livestream
                              </span>
                            </div>
                            <div className={styles.textList}>
                              <span className={styles.checkMark}>
                                <IconPlusCheckMark />
                              </span>
                              <span className={styles.featureText}>
                                Access Anytime, On the Go
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={styles.price}>
                        <span className={styles.priceValue}>$14.</span>
                        <span className={styles.decimalValue}>99</span>
                        &nbsp;/month
                      </div>

                      <div className={styles.promoText}>
                        <em>
                          Currently on cnbc.com and iOS & Android apps. Full
                          episodes cannot be accessed outside the U.S until late
                          2024.
                        </em>
                      </div>

                      <div className={styles.buttonContainer}>
                        <LinkAuthFlow
                          className={styles.ctaButton}
                          product={product}
                          modalType={'signUp'}
                          textAlign={'center'}
                          contentType={'homepage'}
                        >
                          Subscribe to CNBC+
                        </LinkAuthFlow>
                      </div>

                      <div className={styles.learnSignInButton}>
                        <Link
                          className={styles.clickButton}
                          target="_top"
                          to={learnMoreUrl}
                        >
                          Learn More
                        </Link>
                        <div className={styles.orSpan}>&nbsp;or&nbsp;</div>
                        <LinkAuthFlow
                          className={styles.clickButton}
                          product={product}
                          modalType={'signIn'}
                          contentType={'homepage'}
                        >
                          Sign In
                        </LinkAuthFlow>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.plusContent}>
                  <div className={styles.cableContainer}>
                    <div className={styles.subText}>
                      Prefer to watch CNBC via cable?
                    </div>
                    <div className={styles.logoPro}></div>
                    <Link
                      className={styles.signInButton}
                      to={cableProviderLink}
                      target="_top"
                    >
                      Choose your provider
                      <span className={styles.signInButtonRightArrow}>
                        <IconArrowRight />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Gate>
    </Theme>
  );
};

export default GateVideoBreaker;
